module.exports = __webpack_public_path__ + "static/media/ok.af7c6a87.svg";